<div class="nudge-wrapper" [class]="type">
  <img loading="lazy" data-src="/assets/images/star-accelerate.png" alt="star accelerate" />
  <div class="text" *ngIf="type === 'form'">
    Contribute and we'll add another <span> ₹100 </span> from our end
  </div>
  <div class="text" *ngIf="type==='payment'">
    You contribute {{ donation }} campaigner gets {{donation + 100}}
  </div>
</div>